import React from 'react';
import { colors } from '../../constants/colors';

const TermsConditions = () => {
  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: colors.dark_blue, height: "100vh" }}>
      <div
        style={{
          backgroundColor: "white",
          color: "black",
          padding: "20px",
          borderRadius: "10px",
          width: "90%",
          height: "90%",
          overflowY: "scroll",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
        }}
      >
        <h1 style={{ textAlign: "center", marginBottom: "20px" }}>Terms and Conditions</h1>
        <p><strong>Effective Date:</strong> January 1st, 2025</p>
        <p>Welcome to Eventyol, a mobile platform that helps users discover and join local sports and social events. By downloading, accessing, or using the Eventyol mobile application ("App") or any services provided through the App (collectively, the “Service”), you agree to be bound by the following Terms and Conditions.</p>
        <p>Please read them carefully.</p>
        <h2>1. Acceptance of Terms</h2>
        <p>By using the Eventyol App, you agree to these Terms and our Privacy Policy. If you do not agree, please do not use the App.</p>
        <h2>2. Participation Disclaimer and Assumption of Risk</h2>
        <p>Eventyol connects users to independently hosted events. We do not organize, supervise, or control these events. Participation in any event listed on our platform is at your own risk.</p>
        <p>You acknowledge that sports and social events carry inherent risks, including but not limited to physical injury, property damage, or other harm. By attending an event, you voluntarily assume all risks and agree that Eventyol is not liable for any damages, injuries, losses, or accidents that occur during or as a result of any event.</p>
        <h2>3. Limitation of Liability</h2>
        <p>To the fullest extent permitted by law, Eventyol and its affiliates, employees, and agents shall not be held liable for any direct, indirect, incidental, or consequential damages resulting from your use of the App or participation in any listed event.</p>
        <h2>4. Marketing Communications</h2>
        <p>By registering with Eventyol, you agree that we may contact you via email for marketing purposes, including event reminders, promotions, and updates related to our services. You may unsubscribe from marketing emails at any time by contacting us at info@eventyol.org.</p>
        <h2>5. Photo and Video Usage</h2>
        <p>By participating in events promoted or listed through Eventyol, you grant Eventyol the right to use photographs, video, or other media captured during events for promotional, advertising, and social media purposes. These materials may be used without your prior review or approval.</p>
        <p>If you prefer not to be included in such media, please notify the event organizer or photographer before the event begins.</p>
        <h2>6. User Conduct</h2>
        <p>You agree not to misuse the Service or violate any laws while using the App. We reserve the right to suspend or terminate your access if you violate these Terms.</p>
        <h2>7. Modifications</h2>
        <p>We may update these Terms at any time. Continued use of the App after changes become effective constitutes acceptance of those changes. Please review these Terms periodically.</p>
        <h2>8. Contact</h2>
        <p>For any questions about these Terms and Conditions, please contact us at:</p>
        <p>Email: info@eventyol.org</p>
        <p>Website: <a href="https://eventyol.org" target="_blank" rel="noopener noreferrer">https://eventyol.org</a></p>
      </div>
    </div>
  );
};

export default TermsConditions;